/* eslint-disable */
export enum FeatureFlagsEnum {
    LandrGuitarPlugin = 'P_LandrGuitar',
}
